// extracted by mini-css-extract-plugin
module.exports = {"container":"_2CnlK62QxSnjNJ_JF7m6SL"};